import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import { format, parse } from 'date-fns';
import { LocaleDateFormatHelper } from './locale-date-format-helper';

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  constructor(private localeHelper: LocaleDateFormatHelper) {
    super();
  }

  override parse(value: string): Date | null {
    if (!value) return null;
    const dateFormat = this.localeHelper.getDateFormat();
    return parse(value, dateFormat, new Date());
  }

  override format(date: Date, displayFormat: string): string {
    const dateFormat = this.localeHelper.getDateFormat();
    return format(date, dateFormat);
  }
}
